<template>
<span>
    

              <v-tooltip bottom>
                                    <v-btn slot="activator" 
                                            color="green darken-2"
                                            icon
                                            flat
                                            text-color="white"
                                            dark
                                            @click.native="openModal()">
                                        <v-icon class="material-icons"  dark color="green">add</v-icon>
                                    

                                    </v-btn>
                                    <span>Criar nova coluna personalizável</span>
                </v-tooltip>


          <v-dialog @keydown.esc="dialog = false" @keydown.enter="newColumn()" v-model="dialog" max-width="500px">
            <v-card>
            <v-card-title>
                <span><strong>Adicionar nova coluna personalizável</strong></span>
                <v-spacer></v-spacer>
                <v-menu bottom left>
                <v-list>
                    <v-list-tile>
                    <v-list-tile-title>
                        
                    </v-list-tile-title>
                    </v-list-tile>
                </v-list>
                </v-menu>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                    <h4>Nome da coluna</h4>
                    <v-form ref="newColumn" >
                      <v-text-field
                          ref="inputText"
                          counter="30"
                          :rules="rules"
                          placeholder="Ex: anotação"
                          v-model="columnName"
                      ></v-text-field>
                    </v-form>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-switch  color="success" :label="`Acrescentar coluna nas buscas da tabela`" v-model="columnPesq"></v-switch>
                    </v-flex>
                </v-layout>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="primary" flat @click.stop="dialog=false">Fechar</v-btn>
                <v-btn color="success"  @click.stop="newColumn()">Criar</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>

        
</span>

</template>

<script>
export default {
  props: ["table","empresa"],
  data: () => ({
    dialog: false,
    columnName: "",
    columnPesq: false,
    text: "",
    rules: [
      v => v.length <= 30 || "Máximo 30 caracteres para criação da coluna. ",
      v => !(new RegExp(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').test(v)) || "Não é possível o uso de caracteres especiais"
    ]
  }),
  watch: {},
  methods: {
    openModal: function() {
      this.dialog = true;
      this.columnName = "";
      this.columnPesq = false;
    },

    newColumn: function() {

      if (this.columnName && this.columnName.length <= 30 && this.$refs.inputText.validate()) {
        let pos = 0;
        this.table.auxHeaders.forEach(function(item) {
          if (item.show) pos++;
        });
        let chave = "";
        let newHeader = { show: true, enable: true };
        newHeader["text"] = this.columnName;
        chave = `custom_${this.columnName.split(" ").join("")}_${this.empresa._id}`;
        newHeader["value"] = chave;
        newHeader["pesq"] = this.columnPesq;
        this.table.auxHeaders.splice(pos, 0, newHeader);
        this.table.auxNotas.push(chave);

        this.dialog = false;
        this.table.snack.text = `Coluna "${
          this.columnName
        }" adicionada ao fim da tabela`;
        this.table.snackSuccess();
        this.table.snack.show = true;

        this.table.addedCustomColumn = true;
      }
    }
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnColumn/btnNewColumn/BtnNewColumn.vue